// Google OAuth callback handler
// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { CheckCircle2, AlertCircle } from "lucide-react";

export default function GoogleCallback() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const [status, setStatus] = useState("processing");
  const [message, setMessage] = useState("Ansluter ditt Google-konto...");

  useEffect(() => {
    const run = async () => {
      const code = params.get("code");
      const state = params.get("state");
      const errParam = params.get("error");
      if (errParam) {
        setStatus("error");
        setMessage(`Avbröts: ${errParam}`);
        return;
      }
      if (!code) {
        setStatus("error");
        setMessage("Ingen kod mottagen");
        return;
      }
      try {
        // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
        const redirectUri = window.location.origin + "/auth/google";
        const { data } = await api.post("/google/callback", {
          code,
          redirect_uri: redirectUri,
          state,
        });
        setStatus("success");
        setMessage(`Ansluten som ${data.email}${data.label ? ` (${data.label})` : ""}`);
        toast.success(data.label ? `Google-konto "${data.label}" anslutet` : "Google-konto anslutet");
        setTimeout(() => nav("/installningar"), 1200);
      } catch (e) {
        setStatus("error");
        setMessage(e?.response?.data?.detail || "Något gick fel");
      }
    };
    run();
  }, [params, nav]);

  return (
    <div className="app-container flex items-center justify-center px-6" data-testid="google-callback-page">
      <div className="text-center max-w-sm">
        {status === "processing" && (
          <>
            <div className="w-12 h-12 border-4 border-[color:var(--moss)] border-t-transparent rounded-full animate-spin mx-auto mb-4" />
            <p className="text-sm text-[color:var(--text-secondary)]">{message}</p>
          </>
        )}
        {status === "success" && (
          <>
            <CheckCircle2 size={48} className="mx-auto text-[color:var(--moss)] mb-3" />
            <p className="text-sm font-medium">{message}</p>
            <p className="text-xs text-[color:var(--text-tertiary)] mt-2">Tar dig tillbaka...</p>
          </>
        )}
        {status === "error" && (
          <>
            <AlertCircle size={48} className="mx-auto text-[#E07A5F] mb-3" />
            <p className="text-sm font-medium">Anslutning misslyckades</p>
            <p className="text-xs text-[color:var(--text-tertiary)] mt-2">{message}</p>
            <button
              onClick={() => nav("/installningar")}
              className="mt-4 text-sm font-medium text-[color:var(--moss)] underline"
              data-testid="callback-back-button"
            >
              Tillbaka till inställningar
            </button>
          </>
        )}
      </div>
    </div>
  );
}
